import styled from "styled-components";

const List = styled.ul`
  padding-left: 20px;
  margin: 0;
  list-style-type: disc;
`;

export default List;
